export const calculatePercent = (pastValue: number, actualValue: number) => {
    return Math.round(100 * ((actualValue - pastValue) / Math.abs(pastValue)));
};

// Same as calculatePercent, but keeps one decimal - month-over-month swings are often under 1% and would
// otherwise all round down to a misleadingly flat "0%".
export const calculatePercentPrecise = (pastValue: number, actualValue: number) => {
    return Math.round(1000 * ((actualValue - pastValue) / Math.abs(pastValue))) / 10;
};

export const getPercentMeaning = (percent: number) => {
    if (percent > 0) {
        return `wzrost`;
    }

    if (percent < 0) {
        return `spadek`;
    }

    return `stagnację`;
};

// same meaning as getPercentMeaning, but as "więcej/mniej" - "o X% więcej/mniej niż...".
export const getPercentMoreLess = (percent: number) => {
    if (percent > 0) {
        return `więcej`;
    }

    if (percent < 0) {
        return `mniej`;
    }

    return ``;
};

// same meaning as getPercentMeaning, but as a verb - "cena ... spada/rośnie/pozostaje stabilna".
export const getPercentTrendVerb = (percent: number) => {
    if (percent > 0) {
        return `rośnie`;
    }

    if (percent < 0) {
        return `spada`;
    }

    return `pozostaje stabilna`;
};

// always signed, always with a value - "(+4%)", "(-1%)", "(0%)".
export const getSignedPercentString = (percent: number) => {
    return percent > 0 ? `+${percent}%` : `${percent}%`;
};

// Typographic minus (−) and Polish decimal comma - "+4,2%" / "−4,2%", zero always "+0%". `invert` flips which
// raw sign reads as "+" - for values where positive means a decrease (e.g. an offer-vs-transaction discount).
export const getSignedPercentComma = (percent: number, invert = false): string => {
    const signedValue = invert ? -percent : percent;
    const sign = percent === 0 || signedValue > 0 ? "+" : "−";

    return `${sign}${Math.abs(percent).toString().replace(".", ",")}%`;
};
export const calculatePercent = (pastValue: number, actualValue: number) => {
    return Math.round(100 * ((actualValue - pastValue) / Math.abs(pastValue)));
};

// Same as calculatePercent, but keeps one decimal - month-over-month swings are often under 1% and would
// otherwise all round down to a misleadingly flat "0%".
export const calculatePercentPrecise = (pastValue: number, actualValue: number) => {
    return Math.round(1000 * ((actualValue - pastValue) / Math.abs(pastValue))) / 10;
};

export const getPercentMeaning = (percent: number) => {
    if (percent > 0) {
        return `wzrost`;
    }

    if (percent < 0) {
        return `spadek`;
    }

    return `stagnację`;
};

// same meaning as getPercentMeaning, but as "więcej/mniej" - "o X% więcej/mniej niż...".
export const getPercentMoreLess = (percent: number) => {
    if (percent > 0) {
        return `więcej`;
    }

    if (percent < 0) {
        return `mniej`;
    }

    return ``;
};

// same meaning as getPercentMeaning, but as a verb - "cena ... spada/rośnie/pozostaje stabilna".
export const getPercentTrendVerb = (percent: number) => {
    if (percent > 0) {
        return `rośnie`;
    }

    if (percent < 0) {
        return `spada`;
    }

    return `pozostaje stabilna`;
};

// always signed, always with a value - "(+4%)", "(-1%)", "(0%)".
export const getSignedPercentString = (percent: number) => {
    return percent > 0 ? `+${percent}%` : `${percent}%`;
};

// Typographic minus (−) and Polish decimal comma - "+4,2%" / "−4,2%", zero always "+0%". `invert` flips which
// raw sign reads as "+" - for values where positive means a decrease (e.g. an offer-vs-transaction discount).
export const getSignedPercentComma = (percent: number, invert = false): string => {
    const signedValue = invert ? -percent : percent;
    const sign = percent === 0 || signedValue > 0 ? "+" : "−";

    return `${sign}${Math.abs(percent).toString().replace(".", ",")}%`;
};
